var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view collection",attrs:{"data-name":"collection"}},[_c('ShowcaseHero',{attrs:{"title":'Prosecco Collection.'}}),_c('CollectionShowcase')],1)}
var staticRenderFns = []

export { render, staticRenderFns }